<template>
  <div>
    <!-- <GlobalTable
      :title="title+' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                :title="title"
                @addForm="addForm"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="user_code">User Code</label>
              <model-select
                class="form-control"
                id="user_code"
                :options="userList"
                v-model="$v.contactUsForm.user_code.$model"
                :isError="$v.contactUsForm.user_code.$invalid"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.contactUsForm.user_code.$invalid"
                class="invalid-feedback-custom"
              >User code should be filled.</div>
            </div>
          </CCol>
        </CRow>
          <!-- <CRow>
            <CCol sm="3">
              <CInput
                label="User Code"
                invalid-feedback="User Code should be filled"
                required
                v-model="$v.contactUsForm.user_code.$model"
                :is-valid="!$v.contactUsForm.user_code.$invalid"
              />
            </CCol>
          </CRow> -->
          <CRow>
            <CCol sm="9">
              <label for="nik">Messages</label>
              <quill-editor style="height: 200px; margin-bottom:70px;"
                :content="content"
                :options="editorOption"
                v-model="$v.contactUsForm.messages.$model"
                @change="onEditorChange($event)">
              </quill-editor>
              <div v-if="$v.contactUsForm.messages.$invalid" class="invalid-feedback-custom">
                Messages harus di isi.
              </div>
              <!-- <CTextarea
                rows="4"
                label="Description"
                invalid-feedback="Description should be filled"
                required
                v-model="$v.contactUsForm.description.$model"
                :is-valid="!$v.contactUsForm.description.$invalid"
              /> -->
            </CCol>
          </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.contactUsForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import vSelect from "vue-select";

import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "ContactUs",
  components: { quillEditor, vSelect, Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "Contact Us",
      userList: [],
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "users_name", type: "string" },
          { name: "messages", type: "string" },
          { name: "date_inserted", type: "date" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "users_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "User",
        },
        {
          datafield: "messages",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Messages",
        },
        {
          datafield: "date_inserted",
          text: "Date Inserted",
          columntype: "datetimeinput",
          filtertype: "date",
          cellsformat: "d",
          cellsalign: "right",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      items: null,
      contactUsForm: tableInterfaces.contact_us,
      isLoading: false,
      addButton: false,
      isEdit: false,
      content: '',editorOption: {},	// data quill

      visibilityShow: false,
      showNeed:false,
      exportNeed:false,
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    contactUsForm: {
      user_code: { required },
      messages: { required },
      date_inserted: { }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function() {
      this.isEdit = false;
      this.getDropdown();
      this.cancelForm();
      this.getFaq();
    },
    getDropdown: function() {
      this.axios.get("/console/master/contact_us/dropdown").then(response => {
        this.userList = response.data.users;
      });
    },
    getFaq: function() {
      this.isLoading = true;
      this.axios.get("console/master/contact_us/listing").then(response => {
        if (response.data.status === 2000) {
          //this.items = response.data.data;
          const temp = this.source;
          temp.localdata = response.data.data;
          this.items = new jqx.dataAdapter(temp);

          this.showInfoNotification({
            title: this.title,
            message: response.data.message
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message
          });
        }
      })
      .catch(error => {
        this.showErrorNotification({
          title: this.title,
          message: error
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    addForm: function() {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function() {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function(item) {
      this.addForm();
      this.isEdit = true;
      this.contactUsForm = item;
    },
    resetForm: function() {
      for (var i in tableInterfaces.contact_us) {
        tableInterfaces.contact_us[i] = null;
      }
      this.contactUsForm = tableInterfaces.contact_us;
    },
    submitForm: function(event) {
      event.preventDefault();
      if (this.isEdit === false) {
        if (confirm("Do you want to add this data ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios.post("console/master/contact_us/add", this.contactUsForm).then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message
              });
            }
          }).catch(error => {
            this.showErrorNotification({
              title: this.title,
              message: error
            });
          }).finally(() => {
            this.isLoading = false;
            this.init();
          });
        }
      }else{
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios.put("console/master/contact_us/update", this.contactUsForm).then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          }).catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          }).finally(() => {
            this.isLoading = false;
            this.init();
          });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.contactUsForm.description = html
    },
  },
  mounted() {
    this.init();
  }
};
</script>
